import { useGetPublicationsQuery } from 'src/api/redux';

/**
 * Hook to fetch publications for a provider using RTK Query
 */
const useGetPublications = ({ providerId }: { providerId: string }) => {
  const { data, error, isLoading } = useGetPublicationsQuery(
    { providerId },
    {
      skip: !providerId,
    }
  );

  return {
    data,
    error,
    isLoading,
  };
};

export default useGetPublications;
